import { render, staticRenderFns } from "./LogoField.vue?vue&type=template&id=5aa39688&scoped=true&"
import script from "./LogoField.vue?vue&type=script&lang=js&"
export * from "./LogoField.vue?vue&type=script&lang=js&"
import style0 from "./LogoField.vue?vue&type=style&index=0&id=5aa39688&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa39688",
  null
  
)

export default component.exports